import {
  TableCell,
  TableHead,
  TableRow,
  Box,
  Typography,
  IconButton,
  TableBody,
  makeStyles,
} from "@material-ui/core";
import { CustomTable } from "../custom-table";
import { ExpandMoreRounded } from "@material-ui/icons";
import { useState } from "react";
import DoctorsRefillTableItem from "./doctors-refill-table-item";
import { capitalizeFirstLetterArray } from "../../helpers";
import { useDoctorsRefillCategories } from "../../hooks/useDoctorsRefillCategories";
export default function DoctorsRefillCategoryTable(props) {
  const { doctors } = useDoctorsRefillCategories();
  const classes = useStyles();
  const [controlCollapse, setControlCollapse] = useState(new Set());
  const handleControlCollapse = (_id, restore) => {
    if (restore) {
      setControlCollapse((prev) => {
        const newState = new Set(prev);
        newState.clear();
        return newState;
      });
      return;
    }
    setControlCollapse((prev) => {
      const newState = new Set(prev);
      if (newState.has(_id)) newState.delete(_id);
      else newState.add(_id);
      return newState;
    });
  };

  return (
    <CustomTable
      propsTable={{
        id: "RefillCategoriesTable",
        style: { tableLayout: "fixed" },
        className: classes.table,
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell className={classes.cell}>
            <Box className={classes.nameCell}>
              <Box>
                <IconButton onClick={() => handleControlCollapse("", true)}>
                  <ExpandMoreRounded
                    style={{
                      color: "white",
                      transition: "transform 0.2s ease",
                      transform:
                        controlCollapse.size > 0
                          ? "rotate(180deg)"
                          : "rotate(0)",
                    }}
                  />
                </IconButton>
              </Box>
              <Box>
                <Typography>Rut</Typography>
              </Box>
              <Box>
                <Typography>Nombre</Typography>
              </Box>
            </Box>
          </TableCell>
          <TableCell className={classes.cell} width={"15%"}>
            <Box>
              <Typography>Especialidades</Typography>
            </Box>
          </TableCell>
          <TableCell className={classes.cell} width={"30%"}>
            <Box>
              <Typography>Categoria</Typography>
            </Box>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {doctors?.map((doctor) => {
          const {
            _id,
            categoryRefill,
            name,
            lastName,
            specialties,
            rut,
            gender,
          } = doctor;
          const fullName = capitalizeFirstLetterArray(`${name} ${lastName}`);
          return (
            <DoctorsRefillTableItem
              _id={_id}
              category={categoryRefill}
              fullName={fullName}
              rut={rut}
              expand={controlCollapse.has(_id)}
              handleControlCollapse={handleControlCollapse}
              key={_id}
              specialties={specialties}
            />
          );
        })}
      </TableBody>
    </CustomTable>
  );
}

const useStyles = makeStyles((theme) => ({
  cell: {
    padding: theme.spacing(0.5),
  },
  nameCell: {
    display: "grid",
    gridTemplateColumns: "0.25fr 0.5fr 1fr",
    alignItems: "center",
    justifyItems: "start",
    [theme.breakpoints.down("xs")]: {
      '& p[data-id="title"]': {
        fontSize: "1.08rem",
      },
    },
  },
  table: {
    "& tbody": {
      "& tr": { border: "none", borderRadius: theme.spacing(2) },
      '& tr[data-type="row"]': {
        '&[data-loading="loading"]': {
          pointerEvents: "none",
          filter: "contrast(0.5) opacity(0.7)",
          "&>*": {
            pointerEvents: "none",
          },
        },
        '& td[data-id="name"]': {
          textAlign: "start",
        },
        '& td[data-id="categoria"]': {
          "&>div": {
            display: "flex",
            alignItems: "center",
          },
        },
        [theme.breakpoints.down("xs")]: {
          backgroundColor: `hsl(from ${theme.palette.primary.main} h s calc(l + 65))`,
          margin: 0,
          transition: "border-radius 0.2s ease 0.1s",
          '& td[data-id="name"]': {
            gridColumn: "span 2",
             '& div[data-id="rut"]':{
              // marginLeft:8,
              marginRight:12
             }
          },
          '& td[data-id="categoria"]': {
            gridColumn: "span 2",
            "& > div": {
              display: "flex",
              alignItems: "center",
            },
          },
          '& td[data-id="especialidades"]': {
            gridColumn: "span 2",
            "&>div": {
              display: "flex",
              alignItems: "center",
            },
          },
          '&[data-state="expand"]': {
            transition: "none",
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,
          },
        },
      },
      '& tr[data-type="collapsable"]': {
        [theme.breakpoints.down("xs")]: {
          backgroundColor: `hsl(from ${theme.palette.primary.main} h s calc(l + 65))`,
          padding: 0,
          marginBottom: theme.spacing(2),
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        },
      },
    },
  },
}));
